import { searchGameInputType } from '@models/layout/headerModel';
import { RootState, AppDispatch } from '@reducers/index';
import { layoutActions } from '@reducers/layout/layoutSlice';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const SearchInputMobile = (props: searchGameInputType) => {
  const {
    searchText,
    onInputKeyEvent,
    handleOnBlur,
    handleSearchDeleteButtonClick,
    searchResultList,
    handleSelectApp,
    handleOnFucus,
    setIsMobileSearch,
    showResult,
  } = props;

  const { selectedAppInfo, isSelectedApp } = useSelector((state: RootState) => state.LAYOUT);

  const dispatch = useDispatch<AppDispatch>();
  const handleMobileSearch = useCallback(() => {
    dispatch(layoutActions.setMobileSearchToggle({ toggle: false, initValue: false }));
  }, []);

  return (
    <div className="search-box-m">
      <button type="button" onClick={handleMobileSearch}>
        <p className="btn-ico-single back">
          <span className="blind">뒤로가기</span>
        </p>
      </button>
      <label>
        <input type="text" className="search-ipt" value={searchText} onChange={onInputKeyEvent} />
      </label>
      {searchText !== '' && (
        <button
          type="button"
          className="btn-ico-single del"
          onMouseDown={(e) => e.preventDefault}
          onClick={handleSearchDeleteButtonClick}
        >
          <span className="blind">del</span>
        </button>
      )}
      {/* 아래는 모바일 화면 리스트임 */}
      {searchResultList.length > 0 && (
        <div className={`search-list active`}>
          <ul>
            {searchResultList.map((item) => (
              <li
                key={`${item.provider_type}_${item.appId}`}
                onMouseDown={() => handleSelectApp(item)}
                onClick={() => handleSelectApp(item)}
              >
                <img src={`${item.icon}`} style={{ width: 25, height: 25 }} />
                <button type="button">
                  <span>{item.title}</span>
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default SearchInputMobile;
